module.exports = __webpack_public_path__ + "img/gzhewm.a92a4feb.jpg";